import React from 'react'
import PropTypes from 'prop-types'
import { space, colors, radius } from 'theme'
import { Text } from 'components/Typography'

const tooltipStyles = {
  display: 'flex',
  minWidth: 200,
  paddingLeft: space.s,
  paddingRight: space.m,
  paddingVertical: space.s,
  fontSize: 12,
  backgroundColor: colors.white,
  borderRadius: radius.s,
}

const GraphTooltip = ({ label, value, hasBoxShadow }) => (
  <div style={{ ...tooltipStyles, ...(hasBoxShadow && { boxShadow: '0px 4px 10px rgba(39, 40, 49, 0.1)' }) }}>
    <Text>{label}:&nbsp;</Text>
    <Text fontWeight="bold">{value}</Text>
  </div>
)

GraphTooltip.defaultProps = {
  hasBoxShadow: false,
}

GraphTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  hasBoxShadow: PropTypes.bool,
}

export default GraphTooltip
